export default __webpack_public_path__ + "static/media/PIG.08e11c4a.wav";